export const ORDERS_FILTER_SELECT_INCIDENTS = 'ordersIncidents';

export enum EIncidentFilters {
  all = 'all',
  lookupMethodFailed = 'lookup_method_failed',
  automationLaunchFailed = 'automation_launch_failed',
  canceledByExecutor = 'canceled_by_executor',
}
